module.exports = __webpack_public_path__ + "img/C03TechRiteofAndrastaTech_ua.85b0e987.webp";